const setGraphData = payload => {
  return {
    type: "setGraphData",
    payload
  };
};
export default setGraphData;
